import React from 'react';
import Board from 'react-trello';
import KanbanCard from './KanbanCard';
import KanbanLaneHeader from './KanbanLaneHeader';
import './KanbanBoard.css';

const BOARD_STYLE = {
  background: 'transparent',
  padding: '5px',
  height: '100%',
  alignItems: 'flex-start',
};

const LANE_STYLE = {
  background: '#f1f5f9',
  borderRadius: 10,
  padding: '8px',
  width: 272,
  height: 'calc(100vh - 220px)',
  minHeight: 300,
  // No display override — keep Section's default `display: inline-flex; flex-direction: column`
  // so lanes flow horizontally in the smooth-dnd Container
  verticalAlign: 'top',
  margin: '0 4px',
};

// Override ScrollableLane to avoid the flex-collapse CSS issue:
// When a flex item has overflow != visible, its min-height auto resolves to 0,
// which collapses it in an auto-height parent. We fix this with explicit minHeight.
const LaneScrollable = React.forwardRef(({ isDraggingOver, children }, ref) => (
  <div
    ref={ref}
    style={{
      flex: 1,
      overflowY: 'auto',
      overflowX: 'hidden',
      minHeight: 120,
      paddingBottom: 8,
    }}
  >
    {children}
  </div>
));
LaneScrollable.displayName = 'LaneScrollable';

const KanbanBoard = ({ data, onCardMove }) => (
  <Board
    data={data}
    onCardMoveAcrossLanes={(fromLaneId, toLaneId, cardId) => {
      if (fromLaneId !== toLaneId) onCardMove(cardId, toLaneId, fromLaneId);
    }}
    components={{
      Card: KanbanCard,
      LaneHeader: KanbanLaneHeader,
      ScrollableLane: LaneScrollable,
    }}
    style={BOARD_STYLE}
    laneStyle={LANE_STYLE}
    draggable
    laneDraggable={false}
    hideCardDeleteIcon
    cardDraggable
  />
);

export default KanbanBoard;
